<template>
    <DateSelectInput
        :with-focus="true"
        :init-from="initDates.from"
        :init-to="initDates.to"
        :placeholder="placeholder"
        :show-header="false"
        :close-on-select="false"
        :reset-dates-on-close="false"
        input-type="simpleInput"
        @input="$emit('input', $event)"
    >
        <!-- <template #after-section>
            <FlexibleDatesFilter />
        </template> -->
    </DateSelectInput>
</template>

<script>
import { getFilterValue } from '~/helpers/queryParser';
import { AVAILABLE_BETWEEN } from '~/config/filterKeys';

import DateSelectInput from '~/components/form-elements/DateSelectInput.vue';

export default {
    components: {
        DateSelectInput,
    },
    props: {
        placeholder: {
            type: String,
            default: null,
        },
    },
    computed: {
        initDates() {
            return getFilterValue(this.$route.query, AVAILABLE_BETWEEN);
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.flex-dates-filter {
    padding: 8px 16px 6px;
}

.datepicker-trigger {
    position: static;
}

::v-deep .mcd {
    &__wrapper {
        top: unset !important; // top is set in style so we have to use !important
        left: 0;
        width: 787px;
        margin-top: 16px;
    }

    &__months-wrapper {
        width: auto;
    }

    &__month {
        min-width: auto;
    }
}

::v-deep .date-range {
    &__dates-wrapper {
        max-width: calc(100% - 40px);

        &__date {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &__main-placeholder {
        color: $gray-dark-2;
    }
}
</style>
